export default __webpack_public_path__ + "static/media/T-Mobile - Logo2.f5106500.png";